import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const Guides = lazy(() => import('pages/guides'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_authenticated/_main/guides')({
  component: GuidesWrapper,
});

function GuidesWrapper(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <Guides />
    </Suspense>
  );
}
